// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3479":"4cb029533d27d189","5662":"8ccb0ec0c1428fc5"}[chunkId] + ".css";
};